import { MachineGroupScheduleTimeRange } from '../calendar/machine-group-schedule-time-range';
import { isArray } from 'util';

export class MachineGroupScheduleTimeRangeBuilder {
  static fromJson(json) {
    return (json)
      ? new MachineGroupScheduleTimeRange(
        json.hash,
        json.reference,
        json.color,
        json.startTime,
        json.endTime,
        json.defaultRange
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(MachineGroupScheduleTimeRangeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/machine-group-schedule-time-range.builder.ts